/**
 * O AxiosHttpClient não rejeita em erro HTTP: devolve o corpo do erro
 * (`{ statusCode, message }`) ou `undefined` quando não houve resposta (rede).
 * Sem esta checagem, as telas tratavam a recusa do backend como "sucesso".
 *
 * Use nas operações de escrita/ação. Lança um `Error` com a mensagem do
 * backend (ou `fallbackMessage` quando não houver mensagem, inclusive em falha
 * de rede) e com o `statusCode` original, para a tela poder tratar um status
 * específico. Diferente do `@validateHttpStatus`, a mensagem pode ir direto
 * para o toast/alerta.
 */
export type HttpResponseError = Error & {
  statusCode?: number
  body?: unknown
}

export function throwIfHttpError<T>(response: T, fallbackMessage: string): T {
  if (response === undefined || response === null) {
    throw httpResponseError(fallbackMessage)
  }
  const body = response as any
  if (typeof body.statusCode === 'number' && body.statusCode >= 400) {
    const message = Array.isArray(body.message)
      ? body.message.join('\n')
      : body.message
    throw httpResponseError(message || fallbackMessage, body.statusCode, body)
  }
  return response
}

function httpResponseError(
  message: string,
  statusCode?: number,
  body?: unknown
): HttpResponseError {
  const error: HttpResponseError = new Error(message)
  error.statusCode = statusCode
  error.body = body
  return error
}
